module.exports = __webpack_public_path__ + "static/media/bg_music.006def2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg_music.mp3
// module id = 0JDF
// module chunks = 1